import React from "react";

const credentials = [
  {
    title: "Azure Developer Associate",
    detail: "Microsoft Certified · AZ-204",
  },
  {
    title: "Azure Fundamentals",
    detail: "Microsoft Certified · AZ-900",
  },
  {
    title: "Eagle Scout",
    detail: "Boy Scouts of America · June 2006 – May 2013",
  },
];

export default function About() {
  return (
    <div className="mx-auto max-w-page px-5 py-16 md:px-10 md:py-24">
      <p className="label text-ink-soft">03 / About</p>

      <div className="mt-8 grid gap-12 md:grid-cols-12 md:gap-8">
        <div className="md:col-span-8">
          <p className="display font-serif text-3xl font-light leading-[1.15] tracking-tight md:text-5xl">
            Microsoft Certified Azure Developer with full-stack range across C#, ASP.NET Core, Blazor, and modern JavaScript frameworks, repeatedly trusted to pick up{" "}
            <em className="text-vermilion">unfamiliar technologies</em> mid-engagement and ship on deadline.
          </p>

          <blockquote className="mt-12 max-w-2xl border-l-2 border-vermilion pl-6 text-lg italic leading-relaxed text-ink-soft">
            “I believe in the power of continuous learning and solution delivery that not only meet requirements but exceed expectations through innovative thinking and meticulous execution.”
          </blockquote>
        </div>

        <aside className="space-y-10 md:col-span-4 md:border-l md:border-ink md:pl-8">
          <div>
            <h3 className="label text-ink-soft">Education</h3>
            <p className="mt-3 text-xl font-semibold leading-snug">University of Northern Iowa</p>
            <p className="mt-1 text-base leading-snug">
              B.A., double major in Computer Science &amp; Interactive Digital Studies
            </p>
            <p className="label mt-2 text-ink-soft">Cedar Falls, IA · May 2019</p>
            <p className="mt-4 text-[0.95rem] leading-relaxed text-ink-soft">
              My interdisciplinary education combined technical computer science fundamentals and interactive digital design principles, giving me a unique perspective on user-centered software development.
            </p>
          </div>

          <div>
            <h3 className="label text-ink-soft">Credentials</h3>
            <ul className="mt-3">
              {credentials.map((item) => (
                <li key={item.title} className="border-b border-ink/25 py-3 first:pt-0">
                  <p className="text-lg font-semibold leading-snug">{item.title}</p>
                  <p className="label mt-1 text-ink-soft">{item.detail}</p>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
}
